import {useSnackbar} from 'notistack'
import {useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import {useAuth} from 'src/contexts/AuthContext'

export default function HandleRedirectWithTokenOnUrl() {
  const {authFromUrlToken, logout: clearStorage} = useAuth()
  const navigate = useNavigate()
  const rawUrl = window.location.href
  const decodedUrl = decodeURIComponent(rawUrl)
  const queryString = decodedUrl.split('?')[1]
  const params = new URLSearchParams(queryString)
  const next = params.get('next')

  const wasGoingTo = rawUrl.split('.com.br')[1]

  const token = params.get('token')
  const {enqueueSnackbar} = useSnackbar()

  async function redirectToNext() {
    if (token) {
      clearStorage()
      const userIsAuthRedirectToNext = await authFromUrlToken(token)
      if (userIsAuthRedirectToNext) return navigate(`/${next}`)

      enqueueSnackbar('Erro ao autenticar código recebido por e-mail', {variant: 'error'})
      return navigate(`/login`)
    }
    localStorage.setItem('redirectToAfterLogin', wasGoingTo)
    navigate(`/login`)
  }

  useEffect(() => {
    redirectToNext()
  }, [])

  return <></>
}
